import { render, staticRenderFns } from "./TaskboardKanbanColumn.vue?vue&type=template&id=85ac0f84&scoped=true&"
import script from "./TaskboardKanbanColumn.vue?vue&type=script&lang=js&"
export * from "./TaskboardKanbanColumn.vue?vue&type=script&lang=js&"
import style0 from "./TaskboardKanbanColumn.vue?vue&type=style&index=0&id=85ac0f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ac0f84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VDivider,VIcon,VSelect,VTextField})
